import React, { useCallback, useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';

import {
  AddMenteeModuleSelector,
  menteeModulesSelector,
  setAddMenteeModule,
  setAddMenteeModuleModalState,
  useAddMenteeModuleMutation,
} from 'features/moduleManagement';
import { Tappable } from '@vectord/components';
import GlobalLoader from 'components/GlobalLoader';

function AddMenteeModuleConfirmButton() {
  const dispatch = useDispatch();
  const menteeModules = useSelector(menteeModulesSelector);
  const menteeModuleToBeAdded = useSelector(AddMenteeModuleSelector);

  const [addMenteeModule, { isSuccess, error, isLoading: isAdding }] =
    useAddMenteeModuleMutation();

  const handleOnClick = useCallback(() => {
    if (!menteeModuleToBeAdded) {
      cogoToast.error('No Academy Module is selected!');
      return;
    }
    if (menteeModuleToBeAdded.academy_module_id == null) {
      cogoToast.error('Please select a module to add!');
      return;
    }
    addMenteeModule({
      email: menteeModuleToBeAdded.email,
      academyModuleId: menteeModuleToBeAdded.academy_module_id,
      menteeModules,
      beforeModuleId: menteeModuleToBeAdded.before_module_id,
      interviewRequired: menteeModuleToBeAdded.interview_required,
      skillContestRequired: menteeModuleToBeAdded.skill_contest_required,
    });
  }, [addMenteeModule, menteeModules, menteeModuleToBeAdded]);

  const handleModalClose = useCallback(() => {
    batch(() => {
      dispatch(setAddMenteeModule(null));
      dispatch(setAddMenteeModuleModalState(false));
    });
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success(
        'Module added successfully. Change the order of the module as per your requirement'
      );
      handleModalClose();
    }
  }, [handleModalClose, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(
        (error as IError)?.data?.message ||
          'There was some problem in adding mentee module. Please try again later!'
      );
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isAdding} />
      <div className="row justify-end">
        <div>
          <Tappable
            onClick={handleOnClick}
            className="btn btn-primary m-h-10"
            disabled={isAdding}
          >
            Add Module
          </Tappable>
        </div>
      </div>
    </>
  );
}

export default AddMenteeModuleConfirmButton;
